import { Suspense, lazy, useContext } from 'react';
import { appDataContext } from '@/context';

import { Helmet } from 'react-helmet-async';

import Banner from '@/components/Banner';
import Infobar from '@/components/Infobar';
import Services from '@/components/Services';
import SocialBanner from '@/components/SocialBanner';
import PresentationText from '@/components/PresentationText';
import BlogSection from '@/components/BlogSection';

const Testimonials = lazy(() => import('@/components/Testimonials'));

// const MessagePopup = lazy(() => import('@/components/popups/MessagePopup'));

const Home = () => {
  const dataContext = useContext(appDataContext);
  const lang = dataContext?.lang;
  const routeMap = dataContext?.routeMap;
  const text = dataContext?.lang;
  return (
    <>
      <Helmet>
        <title>{`${text?.site.metatitle}`}</title>
        <meta name='description' content={text?.site.description || 'MAZOUT.COM'} />
      </Helmet>
      <Infobar />
      <Banner lang={lang} routeMap={routeMap} />
      <Services lang={lang} />
      <SocialBanner lang={lang} routeMap={routeMap} />
      <PresentationText />
      <Suspense fallback={null}><Testimonials text={lang} /></Suspense>
      <BlogSection length='4' text={lang} routeMap={routeMap} />
      {/* <MessagePopup /> */}
    </>
  );
};

export default Home;
